import { Cidade, ContatoEmpresa, Empresa, EmpresaAttributes, error99, Estado, ObsEmpresa, Parceiro, RetAPI } from "../../Utils/Types"
import { Api } from "../../Utils/api"
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export type Field = | 'fantasia' | 'razao' | 'cnpj'

export const EmpresaService = {

    GetAttributes: async (idCompany?: string): Promise<RetAPI> => {

        const resp = await Api('Empresa/attributes', 'get', { idCompany })
        const attributes: EmpresaAttributes = {
            estados: [],
            cidades: [],
            contatos: [],
            observacoes: [],
            parceiros: [],
            empresa: {
                id: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                id_parceiro: 0,
                id_cidade: 0,
                motivo_exclusao: '',
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: '',
                razao: '',
                nome_fantasia: '',
                endereco: '',
                bairro: '',
                numero: '',
                cep: '',
                complemento: '',
                cnpj_cpf: '',
                ie_rg: '',
                cnae: '',
                regime_tributario: {
                    descricao: '',
                    sigla: '',
                },
                ativo: true,
                uf: '',
                url_logo: '',
                cidade: '',
                parceiro: '',
            }
        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []
            let contatos: ContatoEmpresa[] = []
            let observacoes: ObsEmpresa[] = []
            let parceiros: Parceiro[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.parceiros) {

                    parceiros = resp.data.parceiros.map((item: any) => {
                        return {
                            id: item.id,
                            razao: item.razao,
                            fantasia: item.nome_fantasia,
                            endereco: item.endereco,
                            bairro: item.bairro,
                            cep: item.cep,
                            idCidade: item.id_cidade,
                            doc: item.doc,
                            ativo: item.ativo,
                            description: item.razao
                        }
                    })
                    attributes.parceiros = parceiros
                }

                if (resp.data.estados) {
                    estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.codIBGE,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

                if (resp.data.contatos) {
                    contatos = resp.data.contatos.map((item: any) => {
                        return {
                            id: item.id,
                            nome: item.nome,
                            telefone: item.telefone,
                            email: item.email,
                            setor: item.setor,
                        }
                    })
                    attributes.contatos = contatos
                }

                if (resp.data.empresa) {
                    attributes.empresa.id = resp.data.empresa.id
                    attributes.empresa.id_user_insert = resp.data.empresa.id_user_insert
                    attributes.empresa.id_user_last_update = resp.data.empresa.id_user_last_update
                    attributes.empresa.id_user_exclusao = resp.data.empresa.id_user_exclusao
                    attributes.empresa.id_parceiro = resp.data.empresa.id_parceiro
                    attributes.empresa.id_cidade = resp.data.empresa.id_cidade
                    attributes.empresa.motivo_exclusao = resp.data.empresa.motivo_exclusao
                    attributes.empresa.dt_cadastro = resp.data.empresa.dt_cadastro
                    attributes.empresa.dt_last_update = resp.data.empresa.dt_last_update
                    attributes.empresa.dh_exclusao = resp.data.empresa.dh_exclusao
                    attributes.empresa.name_user_insert = resp.data.empresa.name_user_insert
                    attributes.empresa.name_user_last_update = resp.data.empresa.name_user_last_update
                    attributes.empresa.name_user_delete = resp.data.empresa.name_user_delete
                    attributes.empresa.razao = resp.data.empresa.razao
                    attributes.empresa.nome_fantasia = resp.data.empresa.nome_fantasia
                    attributes.empresa.endereco = resp.data.empresa.endereco
                    attributes.empresa.bairro = resp.data.empresa.bairro
                    attributes.empresa.numero = resp.data.empresa.numero
                    attributes.empresa.cep = resp.data.empresa.cep
                    attributes.empresa.complemento = resp.data.empresa.complemento
                    attributes.empresa.cnpj_cpf = resp.data.empresa.cnpj_cpf
                    attributes.empresa.ie_rg = resp.data.empresa.ie_rg
                    attributes.empresa.cnae = resp.data.empresa.cnae
                    attributes.empresa.regime_tributario = { sigla: resp.data.empresa.regime_tributario, descricao: '', }
                    attributes.empresa.ativo = resp.data.empresa.ativo
                    attributes.empresa.uf = resp.data.empresa.uf
                    attributes.empresa.ativo = resp.data.empresa.ativo
                    attributes.empresa.cidade = resp.data.empresa.nome_cidade
                    attributes.empresa.parceiro = resp.data.empresa.nome_parceiro

                    attributes.empresa.id_parceiro = resp.data.empresa.id_parceiro // precisa adicionar na api par buscar o id do parceiro
                }

                if (resp.data.observacoes) {
                    observacoes = await resp.data.observacoes.map((item: any) => {
                        return {
                            id: item.id,
                            titulo: item.titulo,
                            conteudo: item.conteudo,
                            dtCadastro: item.dt_cadastro,
                            usuario: item.nome_usuario,
                        }
                    })
                    attributes.observacoes = observacoes
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (empresa: object): Promise<RetAPI> => {

        const resp = await Api('Empresa/save', 'post', empresa)

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                id: resp.data.empresa.id,
                msg: 'Dados da empresa gravados com sucesso',
                data: resp.data,
                dt_cadastro: resp.data.empresa.dt_cadastro,
                dt_last_update: resp.data.empresa.dt_last_update,
                name_user_insert: resp.data.empresa.name_user_insert,
                name_user_last_update: resp.data.empresa.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('Empresa/filter', 'get', { field, filter_type, filter, id })
        let empresas: Empresa[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: empresas
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.empresa.map((item: any) => {
                    return empresas.push(

                        {
                            id: item.id,
                            id_user_insert: item.id_user_insert,
                            id_user_last_update: item.id_user_last_update,
                            id_user_exclusao: item.id_user_exclusao,
                            id_parceiro: item.id_parceiro,
                            id_cidade: item.id_cidade,
                            motivo_exclusao: item.motivo_exclusao,
                            dt_cadastro: item.dt_cadastro,
                            dt_last_update: item.dt_last_update,
                            dh_exclusao: item.dh_exclusao,
                            name_user_insert: item.name_user_insert,
                            name_user_last_update: item.name_user_last_update,
                            name_user_delete: item.name_user_delete,
                            razao: item.razao,
                            nome_fantasia: item.nome_fantasia,
                            endereco: item.endereco,
                            bairro: item.bairro,
                            numero: item.numero,
                            cep: item.cep,
                            complemento: item.complemento,
                            cidade: item.nome_cidade,
                            cnpj_cpf: item.cnpj_cpf,
                            ie_rg: item.ie_rg,
                            cnae: item.cnae,
                            regime_tributario: item.regime_tributario,
                            ativo: item.ativo,
                            uf: item.uf,
                            parceiro: item.nome_parceiro,

                        }
                    )
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: empresas
            }
        }

        return {
            error: false,
            data: empresas
        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        //senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Empresa/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    CreateContact: async (contato: ContatoEmpresa): Promise<RetAPI> => {

        const resp = await Api('Empresa/Contato/Save', 'post', {
            id: contato.id,
            nome: contato.nome,
            telefone: contato.telefone,
            celular: contato.celular,
            setor: contato.setor,
            email: contato.email,
            idEmpresa: contato.empresaId
        })

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            id: resp.data.contato.id,
            msg: 'Dados gravados com sucesso '
        }
    },

    DeleteContato: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Empresa/Contato/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    BuscarContatos: async (id_empresa: number): Promise<RetAPI> => {

        const resp = await Api('Empresa/Contato/List', 'get', { id_empresa })
        let contactsList: ContatoEmpresa[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contactsList
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
                data: contactsList
            }
        }

        if (resp.data.contatos) {
            contactsList = resp.data.contatos.map((item: any) => {
                return {
                    id: item.id,
                    nome: item.nome,
                    telefone: item.telefone,
                    celular: item.celular,
                    email: item.email,
                    setor: item.setor,
                    empresaId: item.empresa_id,

                    dt_cadastro: item.dt_cadastro,
                    id_user_insert: item.id_user_insert,
                    name_user_insert: item.name_user_insert,
                    dt_last_update: item.dt_last_update,
                    name_user_last_update: item.name_user_last_update
                }
            })
        }

        return {
            error: false,
            data: contactsList
        }

    },

    DeleteObservacao: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Empresa/Obs/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    id: 0,
                }
            }

            let obsList = await resp.data.obsList.map((item: any) => {
                return {
                    id: item.id,
                    dtCadastro: item.dt_cadastro,
                    idUsuario: item.id_usuario,
                    titulo: item.titulo,
                    conteudo: item.conteudo,
                    idEmpresa: item.id_empresa,
                }
            })

            return {
                error: false,
                msg: '',
                id: 0,
                data: obsList,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                id: 0
            }
        }
    },

    SaveObs: async (titulo: string, conteudo: string, idEmpresa: number, id?: number): Promise<RetAPI> => {

        const resp = await Api('Empresa/Obs/Save', 'post', { titulo, conteudo, id_empresa: idEmpresa, id })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || ''
                }
            }

            let obsList = await resp.data.obsList.map((item: any) => {
                return {
                    id: item.id,
                    dtCadastro: item.dt_cadastro,
                    idUsuario: item.id_usuario,
                    titulo: item.titulo,
                    conteudo: item.conteudo,
                    idEmpresa: item.id_empresa,
                }
            })

            return {
                error: false,
                msg: '',
                data: obsList,
            }

        } else {

            return {
                error: true,
                msg: 'Falha ao salvar observação tente novamente'
            }
        }

    },

    BuscarObs: async (idCompany: number): Promise<RetAPI> => {

        const resp = await Api('Empresa/Obs/List', 'get', { id_empresa: idCompany })
        let obsList: ObsEmpresa[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: obsList
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
                data: obsList
            }
        }

        if (resp.data.observacoes) {
            obsList = resp.data.observacoes.map((item: any) => {
                return {
                    id: item.id,
                    titulo: item.titulo,
                    conteudo: item.conteudo,
                    dtCadastro: item.dt_cadastro,
                    usuario: item.nome_usuario,
                }
            })
        }

        return {
            error: false,
            data: obsList
        }

    },
}   